import React from "react";
import { Dialog } from "@mui/material";
import ExceptionsReport from "./report";

const ExceptionsReportDialog = ({ open, onClose, report }) => {
  if (!report) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      <ExceptionsReport report={report} onClose={onClose} />
    </Dialog>
  );
};

export default ExceptionsReportDialog;
